import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import type { ReactElement } from 'react';

import { Row } from '@common/Row';
import { userStore } from '@stores/userStore';

import styles from './AccountData.module.scss';

export const AccountData = observer((): ReactElement => {
  const { accountInfo, getAccountInfo } = userStore;

  useEffect(() => {
    getAccountInfo().then((r) => ({ r }));
  }, [getAccountInfo]);

  return (
    <>
      {accountInfo && (
        <>
          <Row name="Имя пользователя: " value={accountInfo?.userLogin} className={styles.row} />
          <Row
            name="Полное имя: "
            value={`${accountInfo?.lastName ? accountInfo?.lastName + ' ' : ''}
              ${accountInfo?.firstName ? accountInfo?.firstName + ' ' : ''}
              ${accountInfo?.middleName ?? ''}`}
            className={styles.row}
          />
          <Row name="Электронная почта: " value={accountInfo?.email} />
          <div className={styles.rolesTitle}>Роли пользователя</div>
          <div className={styles.roles}>
            {accountInfo.roles?.map((role) => (
              <div key={role} className={styles.role}>
                {role}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
});
